<div *ngIf="loading; else note">
  <glxy-loading-spinner [size]="'small'"></glxy-loading-spinner>
</div>

<ng-template class="notes" #note>
  <div *ngIf="(inEditMode$ | async) === false; else editMode" class="not-editing">
    <div *ngIf="currentNote$ | async as note; else emptyState" class="note">
      {{ note }}
      <div class="button-container" *ngIf="editable$ | async">
        <button class="edit-button" mat-stroked-button (click)="enterEditMode()">
          {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.EDIT' | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #emptyState>
  <glxy-empty-state [size]="'small'">
    <glxy-empty-state-hero>
      <mat-icon>note</mat-icon>
    </glxy-empty-state-hero>
    <p>{{ 'FRONTEND.SALES_OPPORTUNITIES.NO_NOTES_FOR_OPPORTUNITY' | translate }}</p>
    <div *ngIf="editable$ | async">
      <glxy-empty-state-actions>
        <button mat-stroked-button color="primary" (click)="enterEditMode()">
          {{ 'SALES_ACTIVITY.ADD_NOTES' | translate }}
        </button>
      </glxy-empty-state-actions>
    </div>
  </glxy-empty-state>
</ng-template>

<ng-template #editMode>
  <sales-ui-opportunity-notes-edit
    [note]="currentNote$ | async"
    (save)="save($event)"
    (cancel)="cancel()"
  ></sales-ui-opportunity-notes-edit>
</ng-template>
